import {
    createStaticPage,
    getContenfulStaticProps,
} from '@lib/static/static-page'
import { PAGE_OPTIONS } from '@lib/utils/page'

export const getStaticProps = getContenfulStaticProps(PAGE_OPTIONS.SAVE.slug)
export default createStaticPage(PAGE_OPTIONS.SAVE)
